import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
	selector: 'vtr-page-layout',
	templateUrl: './page-layout.component.html',
	styleUrls: ['./page-layout.component.scss']
})
export class PageLayoutComponent implements OnInit {

	@Input() title: string;
	@Input() textId: string;
	@Input() pageCssClass: string;
	@Input() parentPath: string;
	@Input() back: string;
	@Input() backId: string;
	@Input() isInnerBack = false;
	@Input() menuItems: any[];
	@Input() shiftLeftUp = false;
	@Input() shiftRightUp = false;
	@Input() hideBack = false;
	@Output() innerBack = new EventEmitter();
	@Input() hideTitle: boolean;
	@Input() rightColStyle: string;
	@Input() leftColStyle: string;

	constructor(
	) { }

	ngOnInit() {
	}

	onInnerBack() {
		this.innerBack.emit();
	}
}
